// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @helpers
const { toCamelCase } = require('utilities/stringHelper');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @constants
const { SPAIN_COUNTRY_CODE } = require('constants/index');

// @utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
const { PROC_OPEN_YOUNG_CONTACT_DATA } = require('utilities/tagging');

class OpenYoungContactDataSuccess extends React.Component {
    render() {
        const { immHireContactData, immOpenYoungProfileDetails } = this.props;
        const goBackButton = {
            label: (
                <FormattedText
                    format="uppercase"
                    value="openYoungContactData-openYoungContactData_successBackButtonText"
                />
            ),
            url: `/myprofile/edit`
        };
        const fullNameChild = toCamelCase(immOpenYoungProfileDetails.get('fullName'));
        const successMessage = (
            <FormattedText
                value="openYoungContactData-openYoungContactData_successTitleWithName"
                injectedStrings={[fullNameChild]}
            />
        );

        return (
            <WizardSuccess
                mainButton={goBackButton}
                processType={PROC_OPEN_YOUNG_CONTACT_DATA}
                successMessage={successMessage}
            >
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        title={formatText('openYoungContactData-openYoungContactData_newMobile')}
                        onlyChildren
                    >
                        {PersonalDataHelper.formattedPhone(SPAIN_COUNTRY_CODE, immHireContactData.getIn(['mobile', 'value']))}
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('openYoungContactData-openYoungContactData_newAddress')}
                        onlyChildren
                    >
                        {PersonalDataHelper.getHireFormattedAddress(immHireContactData)}
                    </OKInformativeListItem>
                </OKInformativeList>
            </WizardSuccess>
        );
    }
}

OpenYoungContactDataSuccess.propTypes = {
    immHireContactData: PropTypes.object.isRequired,
    immOpenYoungProfileDetails: PropTypes.object.isRequired,
};

module.exports = OpenYoungContactDataSuccess;
